module.exports = __webpack_public_path__ + "static/media/Xeirokrotima_4.0e24b5ca.jpg";